<template>
  <v-dialog :value="dialog" persistent width="300" text="text">
    <v-card color="primary" dark>
      <v-card-text>
        {{text}}
        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ['text'],
  data() {
    return {
    };
  },
  computed: mapState({
    dialog: state => state.loading
  })
};
</script>
